const UTF8_BOM = [0xef, 0xbb, 0xbf];

// FileReader instead of Blob.arrayBuffer(): jsdom lacks the latter
const readBytes = (blob: Blob): Promise<Uint8Array> =>
  new Promise((resolve, reject): void => {
    const reader = new FileReader();
    reader.onload = (): void => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = (): void => reject(reader.error);
    reader.readAsArrayBuffer(blob);
  });

const startsWithBom = async (content: string | Blob): Promise<boolean> => {
  if (typeof content === 'string') {
    return content.charCodeAt(0) === 0xfeff;
  }
  if (content instanceof Blob) {
    const head = await readBytes(content.slice(0, 3));
    return UTF8_BOM.every((byte, index): boolean => head[index] === byte);
  }
  return false;
};

export const downloadDataAsFile = async (fileName: string, content: string | Blob, type: string = 'csv'): Promise<void> => {
  // Server exports may already carry a BOM; a second one shows up as a stray character in Excel
  const bom: BlobPart = type === 'csv' && !(await startsWithBom(content)) ? new Uint8Array(UTF8_BOM) : new Uint8Array([]);
  const url = window.URL.createObjectURL(new Blob([bom, content], {type: `text/${type}`}));

  const attributString = fileName.split('.').reverse()[0] === type ? fileName : `${fileName}.${type}`;

  const link = document.createElement('a');
  link.href = url;
  link.style.cssText = 'display: none';
  link.setAttribute('download', attributString);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};
